export const timeoutSignal = (ms) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), ms);
  if (typeof timer === 'object' && typeof timer.unref === 'function') timer.unref();
  return controller.signal;
};

export default timeoutSignal;
